(function () {
  const sectionContainer = document.querySelector(".sticky-nav-container");
  const navigationOriginal = document.querySelector(
    ".sticky-nav-container .original"
  );
  const navigationClone = document.querySelector(
    ".sticky-nav-container .clone"
  );
  const contentDetails = document.querySelector("#details-container");
  const contentEinnahme = document.querySelector("#einnahme-container");
  const contentInhalt = document.querySelector("#inhalt-container");
  const contentBewertung = document.querySelector("#bewertung-container");
  const linkDetails = document.querySelector("#details-link");
  const linkEinnahme = document.querySelector("#einnahme-link");
  const linkInhalt = document.querySelector("#inhalt-link");
  const linkBewertung = document.querySelector("#bewertung-link");

  const checkNavigationPosition = () => {
    const navigationPosition = navigationOriginal.getBoundingClientRect().top;
    return navigationPosition;
  };

  const checkSectionEndPosition = () => {
    const endPosition = sectionContainer.getBoundingClientRect().bottom;
    return endPosition;
  };

  const checkContentPosition = (element) => {
    const elementTop = element.getBoundingClientRect().top;
    const elementBottom = element.getBoundingClientRect().bottom;
    return { top: elementTop, bottom: elementBottom };
  };

  const showNavigation = () => {
    navigationClone.classList.remove("hidden");
    document.querySelector(".sticky-header").style.top = "-100%";
  };

  const hideNavigation = () => {
    navigationClone.classList.add("hidden");
    document.querySelector(".sticky-header").style.top = "0%";
  };

  const setupNavigation = () => {
    document.addEventListener("scroll", () => {
      const navigationPosition = checkNavigationPosition();
      const sectionEndPosition = checkSectionEndPosition();

      const contentDetailsPosition = checkContentPosition(contentDetails);
      const contentEinnahmePosition = checkContentPosition(contentEinnahme);
      const contentInhaltPosition = checkContentPosition(contentInhalt);
      const contentBewertungPosition = checkContentPosition(contentBewertung);

      if (navigationPosition <= 0 && sectionEndPosition >= 0) {
        showNavigation();
      } else {
        hideNavigation();
      }
      if (
        contentDetailsPosition.top <= 100 &&
        contentDetailsPosition.bottom >= 50
      ) {
        linkDetails.classList.add("selected");
      } else {
        linkDetails.classList.remove("selected");
      }
      if (
        contentEinnahmePosition.top <= 100 &&
        contentEinnahmePosition.bottom >= 50
      ) {
        linkEinnahme.classList.add("selected");
      } else {
        linkEinnahme.classList.remove("selected");
      }
      if (
        contentInhaltPosition.top <= 100 &&
        contentInhaltPosition.bottom >= 50
      ) {
        linkInhalt.classList.add("selected");
      } else {
        linkInhalt.classList.remove("selected");
      }
      if (
        contentBewertungPosition.top <= 100 &&
        contentBewertungPosition.bottom >= 50
      ) {
        linkBewertung.classList.add("selected");
      } else {
        linkBewertung.classList.remove("selected");
      }
    });
  };

  const main = () => {
    setupNavigation();
  };

  addEventListener("DOMContentLoaded", main);
  addEventListener("shopify:section:load", main);
})();
